import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'; // Link 컴포넌트를 임포트합니다.
import './Header.css'; // 스타일링을 위한 CSS 파일을 임포트합니다.
import APP_VERSION from '../version';
import { UserContext } from '../context/UserContext';
import { isBranchSite } from '../utils/site';

const Header = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logout } = useContext(UserContext);

  // branch.klata.or.kr / dev-branch.klata.or.kr 은 현황 2개 화면만 노출한다.
  const menuItems = isBranchSite()
    ? [
      { to: '/branch/place_stat', label: '회차별 고사장현황' },
      { to: '/branch/accept_stat', label: '회차별 접수현황' },
    ]
    : [
      { to: '/place/list', label: '전체고사장목록' },
      { to: '/testing_place/joins', label: '이번회차고사장설정' },
      { to: '/testing_place_schedule/plan', label: '이번회차 고사장 운영계획' },
      { to: '/testing_accept/stat', label: '이번회차 고사장별 접수현황' },
      { to: '/testing_print/list', label: '응시자명단 및 좌석배치도' },
      { to: '/testing_hq_doc/list', label: '자료공유' },
    ];

  const closeMenu = () => setIsMenuOpen(false);

  const handleLogout = () => {
    logout();
    closeMenu();
  };

  const displayName = user?.personObj?.name || user?.name || user?.id || '사용자';

  return (
    <header className="header">
      <div>
        <button onClick={() => navigate('/')} className="back-btn">&lt;</button>
        <a href="https://www.klata.or.kr" className="logo" target="_blank" rel="noreferrer">한국실용글쓰기검정</a>
        <Link to="/" className="root">지역본부</Link>
        <span className="version">v{APP_VERSION}</span>
        <button
          type="button"
          className="menu-btn"
          aria-label="메뉴 열기"
          onClick={() => setIsMenuOpen(true)}
        >
          <span className="menu-icon">☰</span>
        </button>
      </div>

      {isMenuOpen && <button type="button" className="menu-backdrop" aria-label="메뉴 닫기" onClick={closeMenu} />}

      <nav className={`side-menu ${isMenuOpen ? 'open' : ''}`}>
        <button type="button" className="close-btn" aria-label="메뉴 닫기" onClick={closeMenu}>×</button>
        <div className="side-menu-user">
          <span className="side-menu-user-name">{displayName}</span>
          <button type="button" className="side-menu-logout-btn" onClick={handleLogout}>로그아웃</button>
        </div>
        <ul className="side-menu-list">
          {menuItems.map((item) => (
            <li key={item.to}>
              <Link to={item.to} onClick={closeMenu}>{item.label}</Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;